import { configureRequest, replacePathVariables } from '../../../../../networkRequests/apiClient/apiClient.functions'
import urls from '../../../../../networkRequests/apiClient/endpoints'
import { UserRole } from '../../../../../shared/functions/UserRole/userRoleManagement.types'
import {
  GetFulfillmentOrderTripDetailsForAdminErrorResponse,
  GetFulfillmentOrderTripDetailsForAdminRequest,
  GetFulfillmentOrderTripDetailsForAdminSuccessResponse
} from './getFulfillmentOrderTripDetailsForAdmin.types'

export const getFulfillmentOrderTripDetailsForAdminApi = async (
  request: GetFulfillmentOrderTripDetailsForAdminRequest
): Promise<GetFulfillmentOrderTripDetailsForAdminSuccessResponse> => {
  const response = await configureRequest({
    url: replacePathVariables(urls.admin.getFulfillmentOrderTripDetailsForAdmin, {
      orderId: request.orderId
    }),
    method: 'GET',
    headers: {
      'X-User-Role': UserRole.admin
    }
  })

  if (response.status >= 200 && response.status < 300) {
    return response as GetFulfillmentOrderTripDetailsForAdminSuccessResponse
  } else {
    throw response as GetFulfillmentOrderTripDetailsForAdminErrorResponse
  }
}

export default getFulfillmentOrderTripDetailsForAdminApi
